export enum PermissionConjunction {
  All,
  Any,
  NoCheck
}



// WEBPACK FOOTER //
// ./src/shared/permissions/enum/PermissionConjunction.ts